export default __webpack_public_path__ + "static/media/39.8b96314a.jpg";